export default class Member {
  userId: string;
  role: string;
  status: string;
  emailAddress: string;
  teamName: string;
  constructor(starter?: any) {
    starter = starter || {};
    this.userId = starter.userId || null;
    this.role = starter.role || null;
    this.status = starter.status || 'unknown';
    this.emailAddress = starter.emailAddress || null;
    this.teamName = starter.teamName || null;
  }
  getMaskedEmail() {
    return (
      this.emailAddress ||
      ''.replace(/(.{2})(.*)(?=@)/, (gp1, gp2, gp3) => {
        for (let i = 0; i < gp3.length; i++) {
          gp2 += '*';
        }
        return gp2;
      })
    );
  }
}
